import { useQuery } from "@tanstack/react-query";

import { BusinessTicketRequestService } from "../../../../../services/company-office/BusinessTicketService";
// import { useSelector } from "../../../../../store/store";
import {
  getStatusBaseOnApprover,
  getStepBaseOnApprover,
} from "../../../info-technology-process/delete-user-account/utils";
import { transformRequestStatus } from "../../../utils";
import { useSelector } from "../../../../../store/store";

export const useBusinessTicketsRequests = () => {
  const user = useSelector((state) => state.user);
  const userEmail = user?.current?.username;

  const { data = [], ...restResponse } = useQuery<Array<any>>({
    queryKey: ["business-tickets-requests"],
    queryFn: () =>
      BusinessTicketRequestService.getBusinessTicketRequests(userEmail),
  });

  const businessTicketsMyRequests = data.filter(
    (el) => el.createdBy.user.email.toLowerCase() === userEmail.toLowerCase()
  );

  const mappedBusinessTicketsRequests = data.map((record) => {
    const status = getStatusBaseOnApprover(record.fields, userEmail);
    const step = getStepBaseOnApprover(record.fields, userEmail);

    return {
      ...record.fields,
      id: record.id,
      createdByEmail: record.createdBy.user.email,
      createdByName: record.createdBy.user.displayName,
      createdDateTime: record.createdDateTime,
      eRequestStatus: transformRequestStatus(status, { step }),
    };
  }).sort((a,b) => b.id - a.id);

  const mappedBusinessTicketsMyRequests = mappedBusinessTicketsRequests.filter(
    (record) => record.createdByEmail.toLowerCase() === userEmail.toLowerCase()
  ).sort((a,b) => b.id - a.id);

  const guideLink = "https://drive.google.com/file/d/1KF1zPqvLZ5TJ1XloGFtlMJw1Jy03o7iM/view?usp=drive_link"

  return {
    ...restResponse,
    guideLink,
    businessTicketsRequests: data,
    businessTicketsMyRequests,
    mappedBusinessTicketsRequests,
    mappedBusinessTicketsMyRequests,
  };
};
